/*
  Delivery estimate and dispatch countdown.

  Shared by the product page's sticky add-to-cart bar and the cart page's
  sticky checkout bar so the two never quote different dates. Fills every
  [data-pl-delivery-text] on the page and ticks every [data-pl-cutoff].

  Dates are computed on the shopper's own clock rather than in Liquid so the
  markup stays cacheable, which is why the elements ship empty.

  Deliberately re-queries the DOM on every tick rather than caching the node
  lists at load. The bars sit next to markup that gets re-rendered underneath
  them — the theme editor replaces whole sections, apps repaint the product
  form, bfcache restores a whole page — and a re-inserted span is a NEW, empty
  element. Cached lists would leave it blank forever, which shows up as a lone
  clock icon with no text beside it. A querySelectorAll once a second costs
  nothing next to that.

  Loaded with defer, so the DOM is parsed by the time this runs.
*/
(function () {
  var DISPATCH_CUTOFF_HOUR = 11; // 11:00, local time
  var DELIVERY_FROM_DAYS = 2;
  var DELIVERY_TO_DAYS = 5;
  var DATE_FORMAT = { month: 'short', day: 'numeric' };

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  // Just the dates — "Sep 1 - Sep 4". The cart page's card header wants the
  // range without the promise in front of it, and composing the longer string
  // from this one is what stops the two drifting apart.
  function deliveryRange(now) {
    var from = new Date(now);
    from.setDate(now.getDate() + DELIVERY_FROM_DAYS);
    var to = new Date(now);
    to.setDate(now.getDate() + DELIVERY_TO_DAYS);

    return (
      from.toLocaleDateString('en-US', DATE_FORMAT) +
      ' - ' +
      to.toLocaleDateString('en-US', DATE_FORMAT)
    );
  }

  function deliveryText(now) {
    return 'FREE DELIVERY  |  ' + deliveryRange(now);
  }

  // Counts down to today's dispatch cutoff, rolling to tomorrow once passed.
  function cutoffText(now) {
    var deadline = new Date(now);
    deadline.setHours(DISPATCH_CUTOFF_HOUR, 0, 0, 0);
    if (now >= deadline) deadline.setDate(deadline.getDate() + 1);

    var left = Math.max(0, deadline - now);
    var hrs = Math.floor(left / 3600000);
    var mins = Math.floor((left % 3600000) / 60000);
    var secs = Math.floor((left % 60000) / 1000);

    return 'Order within ' + hrs + 'h ' + pad(mins) + 'm ' + pad(secs) + 's';
  }

  function fill(selector, text) {
    var els = document.querySelectorAll(selector);
    for (var i = 0; i < els.length; i++) {
      // Only touch what actually changed — this runs once a second, and
      // rewriting identical text would churn layout for nothing.
      if (els[i].textContent !== text) els[i].textContent = text;
    }
  }

  function paint() {
    var now = new Date();
    fill('[data-pl-delivery-text]', deliveryText(now));
    fill('[data-pl-delivery-date]', deliveryRange(now));
    fill('[data-pl-cutoff]', cutoffText(now));
  }

  // [data-pl-delivery-date] lives in the cart card's header, INSIDE
  // #main-cart-items .js-contents — so every quantity change destroys it and
  // re-inserts it empty. cart.js publishes cartUpdate after that swap, so
  // repainting here fills the new node immediately; on the tick alone the date
  // would be blank for up to a second, on the row the shopper is looking at.
  //
  // typeof guards because constants.js and pubsub.js expose bare consts in
  // classic scripts — same pattern as pujalane-sticky-cart.js. No feedback
  // loop: paint() writes guarded textContent into leaf spans, and the theme's
  // only MutationObserver watches #main-cart-footer .js-contents, which holds
  // none of them.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, paint);
  }

  var ticker = null;

  function start() {
    paint();
    if (ticker === null) ticker = setInterval(paint, 1000);
  }

  function stop() {
    clearInterval(ticker);
    ticker = null;
  }

  start();

  // Tabs throttle timers in the background; resync on return so the countdown
  // never shows a stale value.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') paint();
  });

  // Back/forward cache: the page is frozen whole and restored later, so the
  // countdown has to be repainted and the timer restarted (pagehide stopped
  // it). Covers a normal first load too, harmlessly.
  window.addEventListener('pageshow', start);
  window.addEventListener('pagehide', stop);
})();
